import { createRoute } from '@tanstack/react-router';

import { AccessGuard } from '@/components/guards/access-guard';
import { AuthGuard } from '@/components/guards/auth-guard';

import { PurchaseOrdersPage } from '@/pages/purchase-orders/purchase-orders-page';

import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: 'purchase-orders',
  component: () => (
    <AuthGuard>
      <AccessGuard>
        <PurchaseOrdersPage />
      </AccessGuard>
    </AuthGuard>
  ),
  staticData: {
    titleKey: 'PurchaseOrders',
  },
});
